var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("a-modal", {
    attrs: {
      title: "阅读条款",
      visible: _vm.visible,
      width: 1000,
      footer: null
    },
    on: {
      cancel: () => {
        _vm.$emit("cancel");
      }
    }
  }, [_vm.clauseItem.type === "pdf" ? _c("vue-pdf-embed", {
    attrs: {
      source: _vm.clauseItem.link
    }
  }) : _c("iframe", {
    ref: "clause",
    attrs: {
      src: _vm.clauseItem.link,
      width: "100%",
      height: "700px"
    }
  }), _c("div", {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c("a-button", {
    attrs: {
      type: "primary",
      disabled: _vm.waitTime !== 0
    },
    on: {
      click: function ($event) {
        return _vm.$emit("cancel");
      }
    }
  }, [_vm._v("已阅"), _c("span", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.waitTime !== 0,
      expression: "waitTime !== 0"
    }]
  }, [_vm._v(_vm._s(_vm.waitTime) + "s")])])], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };